import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  campusVideos: [],
  error: null,
  success: false,
};

const campusVideoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_CAMPUS_VIDEO_REQUEST:
    case actionTypes.UPDATE_CAMPUS_VIDEO_REQUEST:
    case actionTypes.DELETE_CAMPUS_VIDEO_REQUEST:
    case actionTypes.READ_CAMPUS_VIDEO_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case actionTypes.SAVE_CAMPUS_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        campusVideos: [...state.campusVideos, action.payload],
      };

    case actionTypes.UPDATE_CAMPUS_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        campusVideos: state.campusVideos.map((item) =>
          item.campusVideoObjId === action.payload.campusVideoObjId
            ? action.payload
            : item
        ),
      };

    case actionTypes.DELETE_CAMPUS_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        campusVideos: state.campusVideos.filter(
          (item) => item.campusVideoObjId !== action.payload.campusVideoObjId
        ),
      };

    case actionTypes.READ_CAMPUS_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        campusVideos: action.payload,
      };

    case actionTypes.SAVE_CAMPUS_VIDEO_FAILURE:
    case actionTypes.UPDATE_CAMPUS_VIDEO_FAILURE:
    case actionTypes.DELETE_CAMPUS_VIDEO_FAILURE:
    case actionTypes.READ_CAMPUS_VIDEO_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    default:
      return state;
  }
};

export default campusVideoReducer;
